// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fAlay","field":"styles_field__3qC9M","fieldCol":"styles_fieldCol__2ObFo","diffCol":"styles_diffCol__3zmkX","diff":"styles_diff__NAe5z"};